import { apiFetch } from './api';
import type { UserDevice } from '../types/models';

export function listMine(): Promise<UserDevice[]> {
  return apiFetch<UserDevice[]>('/me/devices');
}

export function addUserDevice(payload: {
  deviceId: string;
  nickname?: string;
  purchasedAt?: string;
  batteryHealthPct?: number;
  notes?: string;
}): Promise<UserDevice> {
  return apiFetch<UserDevice>('/me/devices', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateUserDevice(
  id: string,
  patch: Partial<Pick<UserDevice, 'nickname' | 'batteryHealthPct' | 'notes' | 'purchasedAt'>>
): Promise<UserDevice> {
  return apiFetch<UserDevice>(`/me/devices/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export function removeUserDevice(id: string): Promise<void> {
  return apiFetch<void>(`/me/devices/${id}`, { method: 'DELETE' });
}
